import $ from "jquery";

class Mp4Export {

    init() {
        // Only initialize on pages/frames that actually contain the MP4 export form
        this.form = $('#export_mp4_form')
        if (this.form.length === 0) {
            return
        }

        this.FPS = 60

        this.MIN_DURATION = 1
        this.MAX_DURATION = 60

        this.MIN_RPM = 1
        this.MAX_RPM = 60

        this.CACHE = []
        this.images = []
        this.isExporting = false

        this.action = this.form.attr('action')
        // Data coming from hidden fields in the form
        this.uuid = this.form.find('[name=variant_uuid]').val()
        this.base_url = this.form.find('[name=base_url]').val() || ''
        const sourceImagesRaw = this.form.find('[name=source_images]').val() || '[]'
        try {
            this.source_images = JSON.parse(sourceImagesRaw)
        } catch(e) {
            console.warn('[MP4Export] Failed to parse source_images JSON', e, sourceImagesRaw)
            this.source_images = []
        }
        const imageCountRaw = this.form.find('[name=image_count]').val()
        this.image_count = parseInt(imageCountRaw || this.source_images.length || 0, 10) || 0
        const aspectRatioRaw = this.form.find('[name=source_aspect_ratio]').val()
        this.source_aspect_ratio = parseFloat(aspectRatioRaw || '1') || 1
        // WebWorker used by ffmpeg script (served from /public/javascripts)
        try {
            this.worker = new Worker('/javascripts/ffmpeg-worker-mp4.js')
        } catch(e) {
            console.error('[MP4Export] Failed to create ffmpeg worker', e)
            this.worker = null
        }
        this.background = this.form.find('[name=export_mp4_background_color]')
        this.duration = this.form.find('[name=export_mp4_duration]')
        this.rpm = this.form.find('[name=export_mp4_rpm]')
        this.height = this.form.find('[name=export_mp4_size]')
        this.target_aspect_ratio = this.form.find('[name=export_mp4_target_aspect_ratio]')
        this.button = this.form.find('button')

        this.init_sliders()
        this.init_form()
        this.init_panel()
    }


    init_form() {
        const that = this

        // Initialize HTML5 color picker
        const colorPicker = $('#export_mp4_color_picker');
        if (colorPicker.length > 0) {
            // Sync color picker with text field
            colorPicker.on('change', function() {
                const color = this.value;
                // Remove # prefix for text field (since we have input group with #)
                const hexValue = color.startsWith('#') ? color.substring(1) : color;
                that.background.val(hexValue);
                that.background.trigger('blur');
            });

            // Sync text field with color picker
            this.background.on('input', function() {
                const color = this.value;
                // Check if it's a valid hex color (without # since we have input group)
                if (color && color !== 'transparent' && /^[a-fA-F0-9]{6}$/.test(color)) {
                    // Add # prefix for color picker
                    const hexColor = '#' + color;
                    colorPicker.val(hexColor);
                }
            });
        }

        this.rpm.on('change', function () {
            const rpm = parseInt(that.rpm.val())
            const viewerInstance = window.viewer();
            if (viewerInstance) {
                viewerInstance.auto_spin_speed(rpm)
            }
        })

        this.duration.on('change', function () {
            const duration = parseInt(that.duration.val())
            const viewerInstance = window.viewer();
            if (viewerInstance) {
                viewerInstance.auto_spin_duration(duration)
            }
        })

        this.background.on('blur', function () {
            // Add # prefix to the hex value for validation
            const hexWithHash = this.value.startsWith('#') ? this.value : '#' + this.value
            const value = parseAndValidateColor(hexWithHash)
            // Keep only the hex value (without #) for display since we have input group
            const displayValue = value === 'transparent' ? value : value
            this.value = displayValue
            that.background.val(displayValue)
            const viewerInstance = window.viewer();
            if (viewerInstance) {
                viewerInstance.background_color(value)
            }
        })

        this.target_aspect_ratio.on('change', function () {
            const value = parseAndValidateTargetAspectRatio(this.value)
            this.value = value
            that.target_aspect_ratio.val(value)
            const viewerInstance = window.viewer();
            if (viewerInstance) {
                if (value === "original") {
                    viewerInstance.background_color("transparent")
                } else {
                    viewerInstance.background_color("#000000")
                }
            }
        })

        this.button.on('click', function () {
            // check is export process is already running
            if (that.isExporting === true) {
                return
            }

            // mark export process as running
            that.isExporting = true

            // prepare images
            that.CACHE = []
            that.images = []

            // set export data
            let parameters = {}
            parameters.background = parseAndValidateColor(that.background.val())
            parameters.height = parseInt(that.height.find('option:selected').val())
            parameters.target_aspect_ratio = parseAndValidateTargetAspectRatio(that.target_aspect_ratio.val())
            if (parameters.target_aspect_ratio === "original") {
                parameters.width = Math.round(parameters.height / that.source_aspect_ratio)
            } else {
                parameters.width = Math.round((parameters.height * 16) / 9)
            }
            parameters.duration = parseAndValidateInt(that.duration.val(), that.MIN_DURATION, that.MAX_DURATION)
            parameters.rpm = parseAndValidateInt(that.rpm.val(), that.MIN_RPM, that.MAX_RPM)

            that.button.prop('disabled', true)
            that.button.text("Preparing...")
            
            $.ajax({
                type: 'PATCH',
                url: that.action,
                data: {
                    project: {
                        exported_mp4_rpm: parameters.rpm,
                        exported_mp4_duration: parameters.duration,
                        exported_mp4_background_color: parameters.background,
                        exported_mp4_target_aspect_ratio: parameters.target_aspect_ratio,
                        exported_mp4_size: parameters.height
                    }
                },
                dataType: 'JSON'
            })

            that.parameters = parameters
            that.loadFrame(0)
        })
    }

    init_panel() {
        if (typeof window.store_viewer_settings === 'function') {
            window.store_viewer_settings()
        }

        // Disable relevant viewer features for MP4 preview
        const viewerInstance = window.viewer();
        if (viewerInstance) {
            viewerInstance.zoom(false);
            if (viewerInstance.settings && viewerInstance.settings.fullscreen) {
                viewerInstance.fullscreen(false)
            }
            viewerInstance.manual_spin(false)
            viewerInstance.auto_spin(true)

            const background = parseAndValidateColor(this.background.val())
            viewerInstance.background_color(background)

            const target_aspect_ratio = parseAndValidateTargetAspectRatio(this.target_aspect_ratio.val())
            if (target_aspect_ratio === "original") {
                viewerInstance.background_color("transparent")
            } else {
                viewerInstance.background_color("#000000")
            }

            const rpm = parseInt(this.rpm.val())
            viewerInstance.auto_spin_speed(rpm)

            const duration = parseInt(this.duration.val())
            viewerInstance.auto_spin_duration(duration)
        }
    }


    init_sliders() {
        const that = this

        // Initialize duration slider
        $('#export_mp4_duration_slider').on('input', function() {
            that.duration.val(this.value)
        }).on('change', function() {
            that.duration.val(this.value)
            that.duration.trigger('change')
        })

        // Initialize RPM slider
        $('#export_mp4_rpm_slider').on('input', function() {
            that.rpm.val(this.value)
        }).on('change', function() {
            that.rpm.val(this.value)
            that.rpm.trigger('change')
        })
    }

    toDataURL(url, callback) {
        const xhr = new XMLHttpRequest()
        xhr.onload = function () {
            const reader = new FileReader()
            reader.onloadend = () => callback(reader.result)
            return reader.readAsDataURL(xhr.response)
        }
        xhr.open('GET', url)
        xhr.responseType = 'blob'
        return xhr.send()
    }

    convertDataURIToBinary(dataURI) {
        const base64 = dataURI.replace(/^data[^,]+,/, '')
        const raw = window.atob(base64)
        const rawLength = raw.length
        const array = new Uint8Array(new ArrayBuffer(rawLength))
        for (let i = 0, end = rawLength, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
            array[i] = raw.charCodeAt(i)
        }
        return array
    }

    loadFrame(frameNumber) {
        const that = this

        // display download progress
        this.setProgress(frameNumber, this.image_count, 'Loading')

        // check if done
        if (frameNumber === this.image_count) {
            this.createFrames()
            return
        }

        // load image
        let image = this.source_images[frameNumber]
        let params = this.parameters
        const imageUrl = `${this.base_url}${image}/resize;w_${params.width};h_${params.height};f_contain;bg_${params.background}/optimize;bg_${params.background}/image.jpg`

        this.toDataURL(imageUrl, function (imgString) {
            // convert and store data
            const data = that.convertDataURIToBinary(imgString)
            that.CACHE.push(data)

            // load next image
            that.loadFrame(frameNumber + 1)
        })
    }

    createFrames() {
        const totalFrameCount = this.parameters.duration * this.FPS
        const rotationsPerSecond = this.parameters.rpm / 60
        const imagesPerSecond = this.image_count * rotationsPerSecond
        const frameDiff = imagesPerSecond / this.FPS

        let currentFrame = 0

        for (let i = 0; i < totalFrameCount; i++) {
            const index = Math.round(currentFrame) % this.image_count
            const data = this.CACHE[index]

            let frameNumber = `${i}`.padStart(4, 0)

            this.images.push({
                name: `img${frameNumber}.jpg`,
                data
            })

            currentFrame += frameDiff
        }

        this.finalizeVideo()
    }


    finalizeVideo() {
        const that = this
        const totalFrameCount = this.parameters.duration * this.FPS

        this.worker.onmessage = function (e) {
            const msg = e.data

            switch (msg.type) {
                case "stderr":
                    if (msg.data.match(/frame=\s*(\d+)/)) {
                        const frame = parseInt(msg.data.match(/frame=\s*(\d+)/)[1])
                        that.setProgress(frame, totalFrameCount, "Processing")
                    }
                    break
                case "exit":
                    break
                case 'done':
                    const blob = new Blob([msg.data.MEMFS[0].data], {type: "video/mp4"})
                    that.done(blob)
                    break
            }
        }

        this.worker.postMessage({
            type: 'run',
            TOTAL_MEMORY: 1024 * 1024 * 1024,
            arguments: [
                "-r", this.FPS.toString(),
                "-i", "img%04d.jpg",
                "-c:v", "libx264",
                "-crf", "1",
                "-vf", `scale=${this.parameters.width}:${this.parameters.height}`,
                "-pix_fmt", "yuv420p",
                "-vb", "20M",
                "out.mp4"
            ],
            MEMFS: this.images
        })
    }

    setProgress(value, total, label) {
        const percent = Math.round(value / total * 100)
        this.button.text(`${label}: ${percent}%`)
        this.button.css({background: `linear-gradient(90deg, #003595 0%, #003595 ${percent}%, #0069d9 ${percent}%, #0069d9 100%)`})
    }

    done(blob) {
        const url = URL.createObjectURL(blob)
        const download = $('<a>')
        download.appendTo($('body'))
        download.attr('href', url)
        download.attr('download', `${this.uuid}.mp4`)
        download[0].click()
        window.URL.revokeObjectURL(url)
        download.remove()

        this.button.prop('disabled', false)
        this.button.css({background: ""})
        this.button.text("Export")

        // unblock export process
        this.isExporting = false
    }
}
// Export the class for Stimulus controllers / tests
export { Mp4Export };